import styled from 'styled-components';
import { display } from 'styled-system';

import { colors, transition } from 'theme';

export const Tooltip = styled(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ display: displayProp, left, top, ...props }: any) => (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div {...props} />
  ),
).attrs(({ left, top }) => ({
  style: {
    left,
    top,
  },
}))`
  position: fixed;
  z-index: 9999;
  transform: translate3d(-50%, 3px, 0);
  background: white;
  border: 0.7px solid ${colors.elementGrey};
  border-radius: 7px;
  opacity: 0;
  color: ${colors.lightContentGrey};
  visibility: hidden;
  font-size: 12px;
  transition: all ${transition};
  transition-property: opacity, transform, visibility;
  ${display};

  ${(props) =>
    props.$showArrow
      ? `&::after {
        content: '';
        position: absolute;
        z-index: -1;
        left: 50%;
        transform: translateX(-50%) translateY(${
          props.positionAbove ? '-50%' : '50%'
        }) rotate(45deg);
        display: block;
        width: 5px;
        height: 5px;
        background: white;
        border: 0.7px solid ${colors.elementGrey};

        ${props.$positionAbove ? 'bottom: -7px' : 'top: -7px'};
      }
      `
      : undefined}
`;

export const TooltipInner = styled.div`
  background-color: white;
  border-radius: 7px;
  padding: 2px 8px;
  z-index: 1;
`;

export const Container = styled.div`
  text-align: left;

  &:hover,
  &:focus,
  &:focus-within {
    ${Tooltip} {
      transform: translate3d(-50%, 3px, 0);
      opacity: 1;
      visibility: visible;
    }
  }
`;
